export default __webpack_public_path__ + "static/media/AetherPhoto7.3161cdc7.jpg";